// Category photographs illustrate a representative activity, not every role.
// These additional IDs need a role-specific visual or the product fallback
// because the category photograph would imply a materially different service.
// IDs already listed in professionImages.js are deliberately omitted.
export const additionalProfessionIdsNeedingSpecificVisual = new Set([
  // Health: a stethoscope does not illustrate ear or foot treatment.
  'MP009', 'MP018',

  // Rehabilitation: stretching is not occupational or speech therapy.
  'MP023', 'MP027',

  // Mental health: creative therapies need their actual medium, not a talking session.
  'MP030', 'MP033', 'MP034', 'MP037', 'MP038',

  // Complementary therapies: meal planning is not hands-on treatment.
  'MP041', 'MP042', 'MP044', 'MP046', 'MP047', 'MP048',

  // Hair: fitting a wig or hair system is not a haircut.
  'MP065',

  // Personal style: a men's jacket fitting is not bra fitting or shopping support.
  'MP066', 'MP069',

  // Fitness: gym floor exercises misstate distinct sports and movement lessons.
  'MP072', 'MP073', 'MP075', 'MP076', 'MP080', 'MP081', 'MP082',

  // Education: a paper-based lesson is not practical, vehicle or performance teaching.
  'MP083', 'MP084', 'MP085', 'MP086', 'MP087', 'MP088', 'MP089',
  'MP090', 'MP091', 'MP093', 'MP094', 'MP095', 'MP097', 'MP098',

  // Childcare: a playroom does not depict birth, feeding or newborn support.
  'MP108', 'MP110', 'MP112',

  // Home care: hands-on older-person care is not legal or child-contact work.
  'MP114', 'MP120', 'MP121', 'MP122',

  // Construction: timber framing would suggest carpentry for unrelated trades.
  'MP149', 'MP151', 'MP152', 'MP156', 'MP157', 'MP162',
  'MP163', 'MP164', 'MP166', 'MP167', 'MP168', 'MP169',

  // Plumbing: copper pipe work is not drainage or chimney and ventilation work.
  'MP173', 'MP174', 'MP181', 'MP182',

  // Electrical: an industrial panel is not aerial, gate or physical security fitting.
  'MP184', 'MP185', 'MP186', 'MP190', 'MP191', 'MP192', 'MP193',

  // Cleaning: household vacuuming misstates specialist and outdoor services.
  'MP197', 'MP198', 'MP201', 'MP202', 'MP203', 'MP204', 'MP205',
  'MP207', 'MP208', 'MP209', 'MP210',

  // Waste: clearing a house is not wheeling out a bin.
  'MP212',

  // Grounds: hedge trimming is not tree, hardscape, pool or design work.
  'MP220', 'MP221', 'MP222', 'MP223', 'MP225', 'MP227', 'MP228',
  'MP230', 'MP231', 'MP232', 'MP233',

  // Property: a visible building inspection is not design or instrument-led work.
  'MP235', 'MP236', 'MP237', 'MP238', 'MP245', 'MP246', 'MP248',
  'MP253',

  // Technology: computer component repair is not work on other equipment.
  'MP272', 'MP273', 'MP274', 'MP275', 'MP276', 'MP277', 'MP280',
  'MP281', 'MP283', 'MP284', 'MP285', 'MP286', 'MP288', 'MP289',
  'MP290',

  // Industrial: machine inspection is not cleaning, racking or welding.
  'MP294', 'MP300', 'MP301',

  // Craft: woodworking is not fitting fabric, repairing clocks or tuning instruments.
  'MP302', 'MP303', 'MP304', 'MP308', 'MP309', 'MP310', 'MP311',
  'MP312', 'MP314', 'MP315',

  // Deliveries: ordinary boxes do not depict meals or specialist art handling.
  'MP324', 'MP329',

  // Land: crop walking does not depict drainage, trees or environmental surveys.
  'MP333', 'MP335', 'MP336', 'MP337', 'MP338', 'MP339',

  // Business: an office meeting is not an auction, field claim or investigation.
  'MP390', 'MP401', 'MP402', 'MP407', 'MP408',

  // Organising: packing a house does not depict funeral, sitting or admin work.
  'MP414', 'MP415', 'MP416', 'MP417', 'MP418', 'MP419',

  // Specialist field work: a construction checklist is not archive, marine or retail work.
  'MP423', 'MP424', 'MP425', 'MP426', 'MP427', 'MP429',
])
